import { CoachProfile, UserRole } from "@joonapp/web-shared"
import { ClientProfile } from "@joonapp/web-shared"
import { useMemo } from "react"

import { useCoachingGroupsQuery } from "../../../networking/coachingGroups/queries"
import { useCoachTodosQuery } from "../../../networking/coachTodos/queries"
import { CoachingGroup } from "../../../types"
import { CoachTodo, CoachTodoType } from "../../../types/coachTodos"
import useCoachSelectStore from "../../clients/hooks/useCoachSelectStore"

export const useClientsWithTodos = () => {
  const { data: coachingGroups } = useCoachingGroupsQuery()
  const { data: todos } = useCoachTodosQuery()
  const { selectedCoachUserId } = useCoachSelectStore()

  const output = useMemo(() => {
    const clientsWithTodos: {
      coachingGroup: CoachingGroup
      todos: CoachTodo[]
    }[] = []

    coachingGroups?.forEach((coachingGroup) => {
      const client = coachingGroup.profiles.find(
        (profile) => profile.role === UserRole.CLIENT
      ) as ClientProfile
      const coach = coachingGroup.profiles.find(
        (profile) => profile.role === UserRole.COACH
      ) as CoachProfile

      if (selectedCoachUserId && coach?.user.id !== selectedCoachUserId) {
        return
      }

      const clientTodos =
        todos?.filter((todo) => todo.client.id === client?.user.id) || []

      if (clientTodos.length > 0) {
        clientsWithTodos.push({ coachingGroup, todos: clientTodos })
      }
    })

    return clientsWithTodos.sort((a, b) => {
      const aHasOnboardTodo = hasOnboardTodo(a.todos)
      const bHasOnboardTodo = hasOnboardTodo(b.todos)

      return Number(bHasOnboardTodo) - Number(aHasOnboardTodo)
    })
  }, [coachingGroups, todos, selectedCoachUserId])

  return output
}

const ONBOARD_TODO_TYPES = [
  CoachTodoType.FIRST_SESSION,
  CoachTodoType.VIDEO_GREETING,
  CoachTodoType.SIGN_TOS,
]

const hasOnboardTodo = (todos: CoachTodo[]) => {
  return todos.some((todo) => ONBOARD_TODO_TYPES.includes(todo.type))
}
